import { Box, Grid, styled } from "@mui/material";
import { HELP_QUESTIONS_CRYPTO, HELP_QUESTIONS_FIAT } from "../constants";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import CoinTypeTab from "components/CoinTypeTab";
import DepositForm from "./Components/DepositForm";
import DepositFormSkeleton from "components/Skeletons/DepositForm.Skeleton";
import DepositOrWithdrawTab from "./Components/DepositOrWithdrawTab";
import HelpBox from "components/HelpBox";
import TermIMG from "assets/images/TermIMG.png";
import { useFormContext } from "react-hook-form";

export function DepositDesktop({
  coinList,
  selectedCoin,
  selectedCoinTypes,
  selectedCoinNetworks,
}) {
  const navigate = useNavigate();

  const { watch } = useFormContext();
  const isDigital = watch("isDigital");

  const [searchParams] = useSearchParams();
  const allSearchParams = Object.fromEntries([...searchParams]);

  return (
    <Grid container spacing={1}>
      <BoxTerm>
        <img src={TermIMG} alt="" />
      </BoxTerm>

      <DepositOrWithdrawTab />

      <CoinTypeTab
        coinList={coinList}
        onChange={(data) =>
          navigate({
            pathname: `/deposit/${data?.id}`,
            search: `?${createSearchParams({
              ...allSearchParams,
              isDigital: data?.isDigital,
            })}`,
          })
        }
      />

      <Grid item xs={7}>
        {coinList ? (
          <DepositForm
            coinList={coinList}
            selectedCoin={selectedCoin}
            selectedCoinTypes={selectedCoinTypes}
            selectedCoinNetworks={selectedCoinNetworks}
            isDigital={isDigital}
          />
        ) : (
          <DepositFormSkeleton />
        )}
      </Grid>

      <Grid item xs={5}>
        <HelpBox
          questions={isDigital ? HELP_QUESTIONS_CRYPTO : HELP_QUESTIONS_FIAT}
          title="راهنما و سوالات متداول"
        />
      </Grid>
    </Grid>
  );
}
const BoxTerm = styled(Box)(({ theme }) => ({
  img: {
    position: "fixed",
    right: "0",
    zIndex: "0",
  },
}));
export default DepositDesktop;
